

























































import Vue from "vue"
import http from './plugins/http';
import { Menu } from "./modules/Menu";
import * as Common from "./commons/common";


export type Datatype = {
  isSignIn: boolean
  user: {login_id: string, name: string, role: string, school_id: string, school_options: object[]}
}

export default Vue.extend({
  computed: {
    userName(): string {
      let sufix = "";
      if(this.$store.state.currentUser.role == Common.RoleEnum.Student || this.$store.state.currentUser.role == Common.RoleEnum.DigitalPaper || this.$store.state.currentUser.role == Common.RoleEnum.PracticeExaminee){
        sufix = "さん";
      }else{
        sufix = "先生";
      }
      return `${this.$store.state.currentUser.name}${sufix}`;
    },
    isSignIn(): boolean {
      const path: string = this.$route.fullPath;
      return path === "/" || path.indexOf("sign_in") != -1 || path.indexOf("/sign_out") != -1 || path.includes("authorized_callback") || path.includes("exam_result_notification/sign_in");
    },
    isDigitalPaper(): boolean {
      return this.$store.state.currentUser.role == Common.RoleEnum.DigitalPaper;
    },
    isCandidate(): boolean {
      return this.$store.state.currentUser.role == Common.RoleEnum.PracticeExaminee;
    },
    isExamResultTopPreview(): boolean {
      return this.$route.fullPath.includes("teacher_site/exam_result_notification_result_top");
    }
  },
  async created(): Promise<void> {
    this.$store.dispatch("hideOverlay");
    const inputs = document.getElementsByTagName("input");
    for(var i = 0; i < inputs.length; i++){
      inputs[0].setAttribute("autocomplete", "off");
    }
      
    await this.searchCurrentInfo();

    this.$bvModal.hide("msg-box");
    this.$store.commit("setIsShowingMsgBox", false);
  },
  methods: {
    to(menu: Menu): void {
      this.$router.push(menu.toUrl).catch((err: any) => {});
    },
    async searchCurrentInfo(): Promise<void> {
      
      if(this.isSignIn){
        await http.get("/api/master_data/mainte_infos").then((response) =>{
          const mainteInfos = response.data;
          this.$store.commit("setMainteInfo", mainteInfos);
        });
      }else{
        await http.get("/api/current_user").then((response) =>{
          this.$store.commit("setCurrentUser", response.data.user);
          this.$store.commit("setSchools", response.data.schools);
          this.$store.commit("setMainteInfo", response.data.mainte_infos);
        }).catch(error=>{
          if(error.response && error.response.status == 422){
            alert(`${error.response.data.errors[0]}`);
            this.signOut();
          }
        });
      }
    },
    logoClick(){
      if(this.$store.state.currentUser.role == Common.RoleEnum.Student){
        this.$router.push(`/${this.$store.state.currentUser.school_id}/student_site/sheet_list`).catch((err: any) => {});
      }else{
        this.$store.dispatch('goSheetList');
      }
    },
    signOut(){
      const url = window.location.href;

      // @ts-ignore
      const params = {access_token: document.cookie.match(/access_token=(.*)/)[1]}
      http.post(`/api/logout/${this.$store.state.currentUser.id}`, params).then((response) => {
        document.cookie = 'access_token=';
        document.cookie = 'smarky_user_id=';
        // URLから生徒ログイン・教師ログインの戻り先判定
        if(url.indexOf("student_site") != -1){
          // 生徒サイトのログイン画面へ
          // URLに付与されている学校IDを抽出しログインページのURLを生成
          const ary = url.split("/");
          const index = ary.indexOf("#") + 1;

          if(ary.length < index + 1 || ary[index] == null || ary[index] == undefined){
            alert("エラーが発生しました。\n一度ブラウザを閉じてから再度ログインページにアクセスしてください。");
          }else{
            // $storeで保持しているログインユーザ情報をクリア
            this.$store.commit("setCurrentUser", null);
            this.$store.commit("setGauthCredentials", "");
            this.$store.commit("setGauthRedirectPath", "");
            var schoolId = ary[index];
            window.location.href = `/#/${ary[index]}/student_site/sign_in`;
          }
        }else if(url.indexOf("digital_paper_site") != -1){
          window.location.href = `/#/digital_paper_site/sign_in`;
        }else if(url.indexOf("candidate") != -1){
          window.location.href = `/#/candidate/sign_out`;
        }else if(url.indexOf("exam_result_notification") != -1){
          window.location.href = `/#/exam_result_notification/sign_out`;
        }else{
          // $storeで保持しているログインユーザ情報をクリア
          this.$store.commit("setCurrentUser", null);
          this.$store.commit("setGauthCredentials", "");
          this.$store.commit("setGauthRedirectPath", "");

          // 教師サイトログイン画面へ
          window.location.href="/#/"
        }
      })
    },
    // チャットの表示状態切り替え
    chatDipsChange(){
      const url = window.location.href;
      let isTeacherSignIn = url[url.length - 1] == "/" && url[url.length - 2] == "#";
      let isTwoFactorSignIn = url.indexOf("sign_in_two_factor") != -1;
      if(window.location.href.indexOf("student_site") == -1 && window.location.href.indexOf("digital_paper") == -1 && (window.location.href.indexOf("sheet_list") != -1 || isTeacherSignIn || isTwoFactorSignIn)){
        // @ts-ignore
        window.zE('webWidget', 'show');
      }else{
        // @ts-ignore
        window.zE('webWidget', 'hide');
      }
    }
  },
  watch: {
    async "$route" (toUrl: any, fromUrl: any){
      this.$bvModal.hide("msg-box");
      this.$store.commit("setIsShowingMsgBox", false);
      this.chatDipsChange();
      this.$store.dispatch("hideOverlay");
      const inputs = document.getElementsByTagName("input");
      for(var i = 0; i < inputs.length; i++){
        inputs[0].setAttribute("autocomplete", "off");
      }
      if(toUrl !== fromUrl){
        await this.searchCurrentInfo();
      }
    }
  },
  mounted(){
    this.chatDipsChange();
  }
});
